// extracted by mini-css-extract-plugin
export default {"label":"FormRadioBtn_label__VIYeY","disabled":"FormRadioBtn_disabled__aUqpR","readonly":"FormRadioBtn_readonly__sfzWu","input":"FormRadioBtn_input__6YufV"};